'use strict';

import './webCamConfig.css';
import React, { Component } from 'react';
import { ToastContainer } from 'react-toastify';
import toast from '../../../toast';
import { css } from 'glamor';
import Clipboard from 'react-clipboard.js';
import { pageReady, screenPageReady, stopPublisher } from '../../../../webrtc';
import {
    Row, Col, Media,
    FormGroup, Label,
    Input, InputGroup, InputGroupAddon, TextField,
    Modal, ModalHeader, ModalBody, NumericInput
} from 'reactstrap';

class RtmpConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            wowzaBitrateTimer: null,
            deviceInfos: { audio: [], video: [] },

        }
    }

    componentDidMount = () => {
        var self = this;
        let screenIsEnabled = localStorage.getItem('screenIsEnabled');
        if (screenIsEnabled && JSON.parse(screenIsEnabled)) {
            setTimeout(() => {
                if (document.getElementById('videoSource'))
                    document.getElementById('videoSource').value = 'screenShared';
            }, 500)
        }
        // navigator?.mediaDevices?.enumerateDevices().then(function (devices) {
        //     self.gotDevices(devices);
        // }).catch(this.handleError);
    }

    componentWillUnmount = () => {
        clearInterval(this.state.wowzaBitrateTimer);
        this.setState({
            wowzaBitrateTimer: null
        })
    }

    refreshAndStart = () => {
        if (window.stream) {
            window.stream.getTracks().forEach(function (track) {
                track.stop();
            });
        }
        let videoSelect = document.querySelector('select#videoSource');
        let videoSource = videoSelect.value;
        const video = document.querySelector('video');
        const mediaStream = video.srcObject;
        stopPublisher();
        if (mediaStream) {
            const tracks = mediaStream.getTracks();
            tracks[0].stop();
            tracks.forEach(track => track.stop())
        }
        window.localStorage.setItem('webCamIsEnabled', false);
        window.localStorage.setItem('screenIsEnabled', false);
        if (videoSource == 'screenShared') {
            window.localStorage.setItem('screenIsEnabled', true);
            screenPageReady();
        } else {
            window.localStorage.setItem('webCamIsEnabled', true);
            pageReady();
        }
    }

    gotDevices = (deviceInfos) => {
        var option = { audio: [], video: [] };
        for (var i = 0; i != deviceInfos.length; i++) {
            var deviceInfo = deviceInfos[i];
            option.value = deviceInfo.deviceId;
            if (deviceInfo.kind === 'audioinput') {
                option.audio.push({
                    label: deviceInfo.label ||
                        'microphone ' + (option.audio.length + 1), value: deviceInfo.deviceId
                });
            } else if (deviceInfo.kind === 'videoinput') {
                option.video.push({ label: deviceInfo.label || 'camera ' + (option.video.length + 1), value: deviceInfo.deviceId });
                // option.video.push({ label: 'Screen Share', value: "screenShared" })
            } else {
            }
        }
        this.setState({
            deviceInfos: option
        })
    }

    getWebCamConfiguration = () => {
        return (<div>
            <div className="AppLive__body">
                <FormGroup>
                    <Label for="audioSource" className="mr-sm-2">Audio</Label>
                    <Input type="select" name="audioSource" id="audioSource" onChange={this.refreshAndStart}>
                        {this.state.deviceInfos.audio.map((option, index) =>
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        )}
                    </Input>
                </FormGroup>
            </div>

            <div className="AppLive__body">
                <FormGroup>
                    <Label for="videoSource" className="mr-sm-2">Video</Label>
                    {/* value will be dynamic */}
                    <Input type="select" name="videoSource" id="videoSource" onChange={this.refreshAndStart}>
                        {this.state.deviceInfos.video.map((option, index) =>
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        )}
                    </Input>
                </FormGroup>
            </div>
        </div>)
    }

    getRtmpConfiguration = () => {
        return (<div>
            <label> URL RTMP</label>
            <div className="AppLive__body">
                <FormGroup>
                    <InputGroup >
                        <Input type="text" defaultValue={this.props.data.rtmpUrl} name="URL-FMS" />
                        <InputGroupAddon addonType="append">
                            <Clipboard button-title="Copy FMS URL" button-className="btn btn-secondary rtmpButton" data-clipboard-text={this.props.data.rtmpUrl} onSuccess={() => { this.copySuccess(true) }}>
                                Copiar
                            </Clipboard>
                        </InputGroupAddon>
                    </InputGroup>
                </FormGroup>
            </div>
            <label>Chave de transmissão</label>
            <div className="AppLive__body">
                <FormGroup>
                    <InputGroup >
                        <Input type="text" defaultValue={localStorage.getItem('wowzaAppName')} name="URL-FMS" />
                        <InputGroupAddon addonType="append">
                            <Clipboard button-title="Copy FMS URL" button-className="btn btn-secondary rtmpButton" data-clipboard-text={localStorage.getItem('wowzaAppName')} onSuccess={() => { this.copySuccess() }}>
                                Copiar
                            </Clipboard>
                        </InputGroupAddon>
                    </InputGroup>
                </FormGroup>
            </div>
        </div>)
    }

    notifySuccess = (msg) => {
        toast.success(msg);
    }

    copySuccess = (copyRtmp) => {
        if (copyRtmp)
            this.notifySuccess("URL de Rtmp copiado com sucesso!");
        else
            this.notifySuccess("Chave de fluxo copiada com sucesso!");
    }

    render() {
        return (
            <div className="url-content">
                <ToastContainer className={{ textAlign: 'center' }} progressClassName={css({ background: '#007aff' })} />
                {this.props.data.isWebcam || this.props.data.isScreen ? this.getWebCamConfiguration() : this.getRtmpConfiguration()}
            </div>)
    }
}

export default RtmpConfig;



// WEBPACK FOOTER //
// ./src/components/DashboardPage/Dashboard/WebCamConfig/webCamConfig.js